import { AMCEnum } from '@roc/feature-utils';

export enum AppraisalAction {
  EXTRA_PAYMENT_LINK = 'EXTRA_PAYMENT_LINK',
  VALUATION_REORDER = 'VALUATION_REORDER',
  VALUATION_RECERTIFICATION = 'VALUATION_RECERTIFICATION',
  START_DISPUTE = 'START_DISPUTE',
  VALUATION_TRANSFER = 'VALUATION_TRANSFER',
  GET_PAYMENT_LINK = 'GET_PAYMENT_LINK',
  RESET = 'RESET',
  DOWNLOAD_REPORT = 'DOWNLOAD_REPORT',
  ADD_APPRAISAL = 'ADD_APPRAISAL',
  LINK_ORDER = 'LINK_ORDER',
  PUSH_1004D_ORDER = 'PUSH_1004D_ORDER',
  PUSH_NEW_ORDER = 'PUSH_NEW_ORDER',
  SET_AS_PRIMARY = 'SET_AS_PRIMARY',
}

export const FINAL_INSPECTION_APPRAISAL_TYPE = 'Final Inspection';
export const LAND_APPRAISAL_TYPE = 'Land Appraisal';

export const APPRAISAL_TYPE_OPTIONS = [
  { value: 'Appraisal', label: 'Appraisal' },
  { value: 'Drive By', label: 'Drive By' },
  { value: FINAL_INSPECTION_APPRAISAL_TYPE, label: 'Final Inspection' },
  { value: LAND_APPRAISAL_TYPE, label: 'Land Appraisal' },
];

export type ActionContext = {
  isInternal: boolean;
  isTechUser?: boolean;
  isTamariskUser?: boolean;
  isUnderwriterRole?: boolean;
  isUnderwriterProduct?: boolean;
  isDecisionCommittee?: boolean;
  canResetValuations?: boolean;
  isCommitteeUser?: boolean;
  valuationStatus?: string;
  hasPendingPayment?: boolean;
  hasCompletedValuation?: boolean;
  loanSubType?: string;
  selectedAmcId?: number;
};

export type ActionDefinition = {
  key: AppraisalAction;
  label: string;
  isVisible: (ctx: ActionContext) => boolean;
};

const COMPLETED_STATUSES = ['completed', 'approved', 'dispute in progress'];
const PUSH_1004D_AMC_IDS = [AMCEnum.TAMARISK, AMCEnum.VSAMC, AMCEnum.EVALZONE];

const isCompleted = (status?: string): boolean =>
  status != null && COMPLETED_STATUSES.includes(status.toLowerCase());

export const GLOBAL_ACTIONS: ActionDefinition[] = [
  {
    key: AppraisalAction.EXTRA_PAYMENT_LINK,
    label: 'Extra Payment Link',
    isVisible: ({ isInternal, isTechUser, isUnderwriterProduct, isTamariskUser, isDecisionCommittee, hasPendingPayment }) => isInternal && (!!isTechUser || !!isUnderwriterProduct || !!isTamariskUser || !!isDecisionCommittee) && !hasPendingPayment,
  },
  {
    key: AppraisalAction.VALUATION_REORDER,
    label: 'Valuation Reorder',
    isVisible: () => false,
  },
  {
    key: AppraisalAction.VALUATION_RECERTIFICATION,
    label: 'Valuation Recertification',
    isVisible: () => false,
  },
  {
    key: AppraisalAction.RESET,
    label: 'Reset',
    isVisible: ({ isInternal, canResetValuations }) => isInternal && !!canResetValuations,
  },
  {
    key: AppraisalAction.ADD_APPRAISAL,
    label: 'Add - Link Appraisal',
    isVisible: ctx =>
      GLOBAL_SUB_ACTIONS.some(a => a.isVisible(ctx)),
  },
];

// Kept for their isVisible rules only — no longer rendered directly in the menu.
export const GLOBAL_SUB_ACTIONS: ActionDefinition[] = [
  {
    key: AppraisalAction.LINK_ORDER,
    label: 'Link Order',
    isVisible: ({ isInternal, selectedAmcId }) => isInternal && (selectedAmcId === AMCEnum.TAMARISK || selectedAmcId === AMCEnum.INTERNAL_VALUATION),
  },
  {
    key: AppraisalAction.PUSH_1004D_ORDER,
    label: 'Order Final Inspection',
    isVisible: ({ isInternal, selectedAmcId }) =>
      isInternal && PUSH_1004D_AMC_IDS.includes(selectedAmcId),
  },
  {
    key: AppraisalAction.PUSH_NEW_ORDER,
    label: 'Push New Order',
    isVisible: ({ isInternal, isTechUser, isTamariskUser }) =>
      isInternal && (!!isTechUser || !!isTamariskUser),
  },
];

export const VALUATION_ACTIONS: ActionDefinition[] = [
  {
    key: AppraisalAction.DOWNLOAD_REPORT,
    label: 'Download Valuation Report',
    isVisible: ({ valuationStatus }) => isCompleted(valuationStatus),
  },
  {
    key: AppraisalAction.START_DISPUTE,
    label: 'Start Dispute',
    isVisible: ({ valuationStatus }) => isCompleted(valuationStatus),
  },
  {
    key: AppraisalAction.VALUATION_REORDER,
    label: 'Valuation Reorder',
    isVisible: () => false,
  },
  {
    key: AppraisalAction.VALUATION_RECERTIFICATION,
    label: 'Valuation Recertification',
    isVisible: () => false,
  },
  {
    key: AppraisalAction.SET_AS_PRIMARY,
    label: 'Set as Primary',
    isVisible: ({ isInternal, isTechUser, isCommitteeUser, valuationStatus }) =>
      isInternal && isCompleted(valuationStatus) && (!!isTechUser || !!isCommitteeUser),
  },
];
